import * as types from "../types/plano";

const INITIAL_STATE = {
  loading: false,
  plano: {},
  planoClienteLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.PLANOS_LOADING:
      return { ...state, loading: action.payload };

    case types.CHANGE_PLANO_CLIENTE_LOADING:
      return { ...state, planoClienteLoading: action.payload };

    case types.CHANGE_CLIENTE_PLANOS:
      return { ...state, plano: action.payload };

    default:
      return state;
  }
};
